import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// import horoscopeData from "./data/viewData"
import DataPointWidget from "components/LH/HC/Panchangaya";
import moment from 'moment';
import ChartKendaraya from "components/LH/HC/Chart";
import "./horoscope-view.css";
import Sidenav from "./side-nav/side-nav";
import HCViewDKPD from "../components/HCViewDKPD";
import HCViewGSW from "../components/HCViewGSW";
import HCViewAspect from "../components/HCViewAspect";
import HCViewArudhaPadas from "../components/HCViewArudhaPadas";
import HCViewErashtaka from "../components/HCViewErashtaka";
import HCViewOther from "../components/HCViewOther";
import HCViewDKDasa from "../components/HCViewDKDasa";
import HCViewD10 from "../components/HCViewD10";
import { useTranslation } from 'react-i18next';
import DateTimePlaceEntry from "components/LH/HC/DateTimePlaceEntry";
import Utility from "../utility/utility";
import { Link, useParams } from "react-router-dom";
import LHHCApiService from "app/services/LHHCApiService";
import TopNavBar from "app/layout/TopNavBar";
import HCViewYoga from "../components/HCViewYoga";
import HCViewAstakaWargaya from "../components/HCViewAstakaWargaya";
import { useLocation } from "react-router-dom";
import { Box, Tab } from "@mui/material";
import Tabs from "@mui/material/Tabs";

function HoroscopeView({ }) {
    const apiService = LHHCApiService();
    let { recordId } = useParams();
    const [horoscopeData, setHoroscopeData] = useState();
    const [panchangaya, setPanchangaya] = useState([]);
    const [horoscopeBasicInfo, setHoroscopeBasicInfo] = useState([]);
    const [yoga, setYoga] = useState([]);
    const { t } = useTranslation();

    const location = useLocation();

    useEffect(() => {
        if (recordId == undefined) {
            setHoroscopeData(null);
        }
    }, [location]);

    useEffect(() => {
        if (horoscopeData) {
            recordId = horoscopeData.req.id;
            setPanchangaya([
                { name: t("Nekatha"), value: horoscopeData.nekatha + " / " + horoscopeData.nekathaPadaya },
                { name: t("Thithiya"), value: horoscopeData.thithiya },
                { name: t("Karanaya"), value: horoscopeData.karanaya },
                { name: t("Yogaya"), value: horoscopeData.yogaya },
                { name: t("Horawa"), value: horoscopeData.hora },
                { name: t("PHorawa"), value: horoscopeData.horaPanchama },
                { name: t("SHorawa"), value: horoscopeData.horaSukshama },
            ]);

            var d1 = moment.duration(horoscopeData.ayanamsa, 'minutes');
            var d2 = moment.duration(d1.asSeconds(), 'minutes');
            const ayanamsaFormated = moment({ m: d1.minutes() }).format('mm:') + moment({ m: d2.minutes(), s: d2.seconds() }).format('mm:ss');

            setHoroscopeBasicInfo([
                { name: t("LAGNAYA"), value: horoscopeData.lagna },
                { name: t("NAWANSAKAYA"), value: horoscopeData.navamsaka },
                { name: t("SunRise"), value: horoscopeData.sunRise },
                { name: t("SunSet"), value: horoscopeData.sunSet },
                { name: t("Ayanamsa"), value: ayanamsaFormated },
                { name: t("NakTime"), value: horoscopeData.nakTime },
            ]);
            if (horoscopeData.yoga) {
                setYoga(horoscopeData.yoga?.map((item) => {
                    return { name: item.name, value: item.significance }
                }));
            }

        }



    }, [horoscopeData])

    const onCalculate = async (hcDataInput) => {
        console.log("hcDataInput", hcDataInput)
        try {
            const data = await apiService.addHc(Utility.getAPIPayLoadForAddHc(hcDataInput));
            setHoroscopeData(data);
            console.log(data);
        } catch (err) {
            console.log(err);
        } finally {
            // setLoading(false);
        }
    }

    useEffect(() => {
        if (recordId) {
            const fetchData = async () => {
                try {
                    const data = await apiService.getHc(recordId);
                    setHoroscopeData(data);
                    console.log(data);
                } catch (err) {
                    console.log(err);
                } finally {
                    // setLoading(false);
                }
            }
            fetchData();
        }
    }, [recordId]);

    const degreesToHoursMinutes = (degrees) => {
        let hours = Math.floor(degrees);
        let minutes = Math.round((degrees - hours) * 60);
        return `${hours}° ${minutes}'`;
    }

    const navItems = [
        // { icon: "arrow_right", label: "ආරම්භය ", href: "start-ref" },
        // { icon: "arrow_right", label: "යෝග", href: "yoga-ref" },
        { icon: "arrow_right", displayOrder: 0, label: "ග්‍රහස්ථුට", href: "planets-ref" },
        { icon: "arrow_right", displayOrder: 1, label: "දසා", href: "dasa-ref" },
        { icon: "arrow_right", displayOrder: 2, label: "ඒරාෂ්ටක", href: "erashtaka-ref" },
        { icon: "arrow_right", displayOrder: 3, label: "දස මංගල ලක්ෂන", href: "ten-facts-ref" },
        { icon: "arrow_right", displayOrder: 4, label: "අමතර", href: "extra-ref" },
        { icon: "arrow_right", displayOrder: 5, label: "ග්‍රහ දෘෂ්ටි", href: "aspect-ref" },
        { icon: "arrow_right", displayOrder: 6, label: "රාශි දෘෂ්ටි", href: "aspect-ref" },
        { icon: "arrow_right", displayOrder: 7, label: "ග්‍රහ ශඩ්වර්ගය", href: "planet-devision-ref" },
        { icon: "arrow_right", displayOrder: 8, label: "ආරූඩ පාද", href: "bases-ref" },
        { icon: "arrow_right", displayOrder: 9, label: "අෂ්ටකවර්ගය", href: "chart-ashtaka-warga-ref" },
    ];

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        console.log("handleChange", newValue);
        setValue(newValue);
    };

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <DashboardLayout className="bg-image">
            <TopNavBar />

            {!recordId && !horoscopeData && <>
                <Card className="time-entry" style={{ textAlign: "center", marginBottom: 4 }}>
                    හඳහනක් සෑදීම
                </Card>
                <Card className="time-entry">
                    <DateTimePlaceEntry onCalculate={onCalculate} />
                </Card>
            </>}
            {horoscopeData &&
                <>
                    <Card id="start-ref" className="card">
                        <MDBox p={2}>
                            <Grid container spacing={3} alignItems="center" className="centent-center">
                                <Grid item>
                                    <MDBox height="100%" mt={0.5} lineHeight={1}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            {t('JANMA_REPORT')}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Card>
                    <Card id="start-ref" className="bg-image-header">
                        <MDBox p={2}>
                            <Grid container spacing={3} alignItems="center">
                                <Grid item>
                                    <MDBox height="100%" mt={0.5} lineHeight={1}>
                                        <MDTypography variant="h5" fontWeight="medium">
                                            {horoscopeData.req.name} - {horoscopeData.req.dateTimeLocalString}
                                        </MDTypography>
                                        <MDTypography variant="button" color="text" fontWeight="medium">
                                            {horoscopeData.req.location} | {degreesToHoursMinutes(horoscopeData.req.latitude)} {horoscopeData.req.latitudeDirection} / {degreesToHoursMinutes(horoscopeData.req.longituede)} {horoscopeData.req.longitudeDirection} | {horoscopeData.req.offsetPeriodName} / {horoscopeData.req.timeZoneId}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Card>
                    <div style={{ marginTop: 4 }}></div>
                    <Card style={{ paddingBottom: 4 }} className="bg-image">
                        <Grid container mt={1} ml={0} pl={1} spacing={4}>
                            {horoscopeBasicInfo.map((item, index) => (
                                <Grid key={"s1" + index} item style={{ paddingTop: 4, paddingLeft: 4 }} xs={6} md={3} lg={1.7}>
                                    <DataPointWidget name={item.name} value={item.value} />
                                </Grid>
                            ))}
                        </Grid>
                        <Grid container mt={1} ml={0} pl={1} spacing={4}>
                            {panchangaya.map((item, index) => (
                                <Grid key={"s2" + index} item style={{ paddingTop: 4, paddingLeft: 4 }} xs={6} md={3} lg={1.7}>
                                    <DataPointWidget name={item.name} value={item.value} />
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                    <Card className="bg-image">
                        <Grid container spacing={3}>
                            <Grid item size={{ xs: 12, md: 6 }} className="centered-grid-item">
                                <ChartKendaraya devision="D1" lagna={horoscopeData.lagna} rashiId={horoscopeData.lagnaId} lagnaSputaya={horoscopeData.lagnaSputaya} planets={horoscopeData.planet} />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }} className="centered-grid-item">
                                <ChartKendaraya devision="D9" lagna={horoscopeData.navamsaka} rashiId={horoscopeData.navamsakaId} lagnaSputaya={horoscopeData.navamsakaSputaya} planets={horoscopeData.planet} />
                            </Grid>
                        </Grid>
                    </Card>
                    <Card className="bg-image">
                        <Grid item size={12}>
                            {yoga.length > 0 && <Grid item xs={12} id="yoga-ref">
                                <HCViewYoga data={yoga} />
                            </Grid>
                            }
                        </Grid>
                        <Grid container spacing={3}>

                            <Grid container spacing={2}>
                                <Grid item size={12}> {/* This ensures the Box takes full width of the grid row */}
                                    <Box
                                        sx={{
                                            // We can actually remove width: '100%' here if Grid item xs={12} ensures full width,
                                            // but it doesn't hurt to keep it for clarity that the Box itself intends to fill.
                                            width: '100%',
                                            overflowX: 'auto', // This is where the horizontal scroll will appear
                                            WebkitOverflowScrolling: 'touch', // For smoother scrolling on iOS
                                            '&::-webkit-scrollbar': { display: 'none' }, // Optionally hide scrollbar
                                            MsOverflowStyle: 'none', // IE and Edge
                                            scrollbarWidth: 'none', // Firefox
                                        }}
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            variant="scrollable"
                                            scrollButtons={true}
                                            allowScrollButtonsMobile={true}
                                            aria-label="scrollable auto tabs example"
                                            xs={{ minWidth: 200 }}

                                            slotProps={{
                                                scrollButtons: {
                                                    sx: {
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: '2rem', // Set arrow icon size
                                                            color: 'red',     // Set arrow color
                                                        },
                                                    },
                                                },
                                            }}



                                        // Optional: You can add minWidth to Tabs if you find they still try to squeeze
                                        // sx={{ minWidth: 'max-content' }}
                                        >
                                            {navItems.map((item, index) => (
                                                <Tab label={item.label} key={item.displayOrder}  {...a11yProps(item.displayOrder)} />))}
                                        </Tabs>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid item size={12}>
                                {navItems.map((item, index) => (
                                    <>
                                        {value == item.displayOrder ? <div value={value} key={item.displayOrder} data-index={item.displayOrder}>
                                            {item.displayOrder === 0 && <HCViewDKPD tableData={horoscopeData.planet} />}
                                            {item.displayOrder === 1 && <HCViewDKDasa tableData={horoscopeData.dasa} />}
                                            {item.displayOrder === 2 && <HCViewErashtaka tableData={horoscopeData.erashtaka} />}
                                            {item.displayOrder === 3 &&
                                                <HCViewD10 data={[
                                                    { name: t("Ganaya"), value: horoscopeData.dmL10.ganaya },
                                                    { name: t("Yoniya"), value: horoscopeData.dmL10.yoni },
                                                    { name: t("Wruksha"), value: horoscopeData.dmL10.wruksha },
                                                    { name: t("Linga"), value: horoscopeData.dmL10.linga },
                                                    { name: t("Nadi"), value: horoscopeData.dmL10.nadi },
                                                    { name: t("Pakshi"), value: horoscopeData.dmL10.pakshi },
                                                    { name: t("Gothra"), value: horoscopeData.dmL10.gothra },
                                                    { name: t("Warna"), value: horoscopeData.dmL10.warna },
                                                    { name: t("Rajju"), value: horoscopeData.dmL10.rajju },
                                                    { name: t("Bhutha"), value: horoscopeData.dmL10.bhutha },

                                                ]} />}
                                            {item.displayOrder === 4 &&
                                                <HCViewOther data={[
                                                    { name: t("Derkana22nd"), value: horoscopeData.derkana22nd },
                                                    { name: t("NawansakaAdipathi64th"), value: horoscopeData.nawansakaAdipathi64th },
                                                    { name: t("H60"), value: horoscopeData.h60 },
                                                    { name: t("ShakaWarshaya"), value: horoscopeData.shakaWarshaya },
                                                    { name: t("Fortuna"), value: horoscopeData.fortuna },
                                                    { name: t("Yogakaraka"), value: horoscopeData.yogakaraka },
                                                ]} />}
                                            {item.displayOrder === 5 && <HCViewAspect title="ග්‍රහ දෘෂ්ටි" tableData={horoscopeData.gAspects} />}
                                            {item.displayOrder === 6 && <HCViewAspect title="රාශි දෘෂ්ටි" tableData={horoscopeData.rAspects} />}
                                            {item.displayOrder === 7 && <HCViewGSW tableData={horoscopeData.planet} />}
                                            {item.displayOrder === 8 && <HCViewArudhaPadas tableData={horoscopeData.arudhaPadas} />}
                                            {item.displayOrder === 9 && <HCViewAstakaWargaya astakaWargaData={horoscopeData.astakaWarga} />}
                                        </div> : <></>
                                        }
                                    </>
                                ))}

                            </Grid>
                        </Grid>
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", position: "relative", top: 0, right: '50%', marginBottom: 8 }}>
                        <Link
                            to="/my-files/horoscope/print/:recordId"
                            state={horoscopeData}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                                color: "#a00",
                                gap: 4,
                                fontWeight: 500
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginLeft: 4 }}>
                                <path d="M19 8H5c-1.1 0-2 .9-2 2v6h4v4h10v-4h4v-6c0-1.1-.9-2-2-2zm-3 10H8v-4h8v4zm3-6H5v-2h14v2zm-2-8H7v4h10V4z" />
                            </svg>
                            <span>Print</span>
                        </Link>
                    </div>
                    </Card>

                    
                </>}
        </DashboardLayout >
    );
};

export default HoroscopeView;